// ==============================
// Data for the menu component
// ==============================

import {
  PhoneIcon,
  ChatBubbleLeftRightIcon,
  MapPinIcon,
} from "@heroicons/react/24/outline";

// Types

// ==============================
// Data for the menu component
// ==============================

export type SubMenuItem = {
  label: string;
  link: string;
};

export type MenuItem = {
  label: string;
  link?: string;
  submenu?: SubMenuItem[];
};

export const menu: MenuItem[] = [
  { label: "Home", link: "/" },
  { label: "About Us", link: "/about" },
  {
    label: "What We Do",
    link: "#",
    submenu: [
      { label: "What We Do", link: "/what-we-do" },
      { label: "Investment Banking", link: "/investment-banking" },
      { label: "Investment Management", link: "/investment-management" },
      { label: "Research & Trading", link: "/research-trading" },
    ],
  },
  { label: "Our Business Commitments", link: "/business-commitments" },
  { label: "Careers", link: "/careers" },
  // { label: "ACQ Insights", link: "/acq-insights" },
];

// Path: src/app/components/shared/navbar.tsx

// ==============================
//  Home Page Component
// ==============================

export const services = [
  {
    img: "/homepage/investment-banking.svg",
    title: "Investment Banking",
    description:
      "Arranging the issuance of securities, financial advisory and corporate finance.",
    link: "/investment-banking",
  },
  {
    img: "/homepage/investment-management.png",
    title: "Investment Management",
    description:
      "Constructing portfolios and managing funds on behalf of institutional and high net worth investors.",
    link: "/investment-management",
  },
  {
    img: "/homepage/research-and-trading.svg",
    title: "Research & Trading",
    description:
      "Buying and selling of securities on behalf of its customers and for itself.",
    link: "/research-trading",
  },
];

export const competitiveAdvantages = [
  {
    img: "/adVector1.svg",
    title: "Local Expertise",
    description:
      "In-depth knowledge of the African market and regulatory environment.",
  },
  {
    img: "/adVector2.svg",
    title: "Client-Centric Approach",
    description:
      "Tailored solutions based on client needs and fostering long-term relationships.",
  },
  {
    img: "/adVector2.svg",
    title: "Technology Integration",
    description:
      "Utilization of advanced technology for seamless transactions and real-time market insights.",
  },
  {
    img: "/adVector4.svg",
    title: "Comprehensive Services",
    description:
      "A full suite of financial services covering debt & equity financing, corporate finance, asset management, as well as research & trading.",
  },
  {
    img: "/adVector1.svg",
    title: "Risk Management",
    description:
      "Rigorous risk management protocols to safeguard client investments and ensure regulatory compliance. Continuous monitoring of market trends, geopolitical events, and economic indicators.",
  },
];

// ==============================
//  Footer Component
// ==============================
export const socials = [
  {
    img: "/socials/linkedIn.svg",
    label: "LinkedIn",
    link: "#",
  },
  {
    img: "/socials/x.svg",
    label: "Twitter",
    link: "#",
  },

  {
    img: "/socials/instagram.svg",
    label: "Instagram",
    link: "#",
  },
  {
    img: "/socials/facebook.svg",
    label: "Facebook",
    link: "#",
  },
];

export const aboutFooterSection = [
  {
    type: "heading",
    content: "About",
    href: "/about",
  },
  {
    type: "link",
    href: "/about",
    text: "Our Firm",
  },
  {
    type: "link",
    href: "/about",
    text: "Leadership",
  },
  {
    type: "link",
    href: "/business-commitments",
    text: "Our Commitments",
  },
];

export const businessFooterSection = [
  {
    type: "heading",
    content: "Our Businesses",
    href: "#",
  },
  {
    type: "link",
    href: "/",
    text: "Our Services",
  },
  {
    type: "link",
    href: "/about/#leadership-team",
    text: "Our Team",
  },
  {
    type: "link",
    href: "/contact",
    text: "Contact Form",
  },
];

// ==============================
//  About us Page Component
// ==============================

export const coreValues = [
  {
    title: "Accountability",
    description: "Working with integrity and always doing the right thing",
    img: "/about/accountability.svg",
  },
  {
    title: "Client-Focus",
    description: "Prioritizing the client",
    img: "/about/client-focus.svg",
  },
  {
    title: "Quintessence",
    description: "Leading with quality and class",
    img: "/about/quintessence.svg",
  },
  {
    title: "Innovation",
    description: "Winning with exceptional ideas",
    img: "/about/innovation.svg",
  },
  {
    title: "Excellence",
    description: "Staying committed to high standards",
    img: "/about/excellence.svg",
  },
  {
    title: "Respect",
    description:
      "Having regard for our clients, employees, partners, and stakeholders",
    img: "/about/respect.svg",
  },
];

export const leadership = [
  {
    img: "/about/seun.svg", // Replace with actual image path
    name: "Seun Onayiga",
    role: "Co-Founder/Managing Director, ACQ Capital Managers",
    bio: `Seun Onayiga is a senior finance professional with almost two decades of investment banking, investment research, private equity and VC investing experience. He is the Managing Director & CEO of ACQ Capital Managers – the investment banking business of ACQ Managers. Seun has executed and advised on over US$12 billion worth of transaction, across various products in over 17 African countries.
    
    Prior to ACQ Managers, Seun was a Managing Director & Head of the Africa business at BancTrust & Co. – a U.K headquartered, EM-focused, debt specialist investment bank.

    Before joining BancTrust, he was a Managing Director at Renaissance Capital (RenCap), where he spent a dozen years. He headed and was responsible for setting and executing the firm's West Africa and then later, the SSA investment banking strategy. In that role, Seun spearheaded deal origination, structuring and execution of transactions across products and was also responsible for managing the P&L of the region, making capital allocation decisions, vision setting and upholding the corporate culture of the franchise

    Prior to RenCap, Seun had stints with Africapital Management – an energy and infrastructure focused advisory firm; Emerging Capital Partners – the Washington D.C. headquartered, Africa-focused, Private Equity fund; Afrinvest (West Africa) - one of Nigeria's foremost investment banking boutiques, where he started his finance career as an investment research analyst; as well as with Julius Berger Nigeria Plc.

    Seun holds an MBA from the Lagos Business School, Pan-Atlantic University and a Bachelors degree in Electrical /Electronics Sciences from the University of Science and Technology, Rivers State.

    He serves on the boards of multiple leading African corporations.`,
  },
  {
    img: "/about/yinka.svg", // Replace with actual image path
    name: "Yinka Odeleye",
    role: "Co-Founder/Managing Director, ACQ Investment Managers",
    bio: `Yinka Odeleye boasts over two decades of experience in finance, investment banking, and private equity. His illustrious career is marked by a remarkable journey across diverse sectors and esteemed institutions, solidifying his expertise and influence in the financial landscape. He is the Managing Director & CEO of ACQ Investment Managers – the investment management business of ACQ Managers.
    
    With extensive experience in investment banking, Yinka served as the Managing Director of Union Capital Markets Limited in Lagos, Nigeria, and held leadership roles at Citibank Nigeria and Lehman Brothers in New York. He has facilitated over US$15 billion worth of investment banking and financing transactions globally, particularly in financial institutions, fintech, health-tech, energy, and consumer sectors

    He is the founder of Rex Africa, a pioneering neo-bank, and the Co-Founder of Sojorne, a cutting-edge Health-tech startup in Atlanta, Yinka showcases his entrepreneurial spirit and visionary leadership in shaping innovative solutions for the modern financial and healthcare sectors.

    Recognized by Euromoney financial publication in May 2014 as one of the top 20 rising stars of African finance, Yinka holds a CFA charter, an MBA in Finance & Marketing from Rutgers Business School NJ, and is affiliated with prestigious financial institutes like the Chartered Institute of Bankers of Nigeria and the New York Society of Securities Analysts.
    `,
  },
];

export type TFeaturedCredentials = {
  img?: string;
  company: string;
  amount?: string;
  transaction: string;
  country: string;
  year: number;
};

export const featuredCredentials: TFeaturedCredentials[] = [
  {
    img: "/icons/mtn.svg",
    company: "MTN",
    amount: "US$ 2,000,000,000",
    transaction: "Restructuring medium-term facility",
    country: "Nigeria",
    year: 2010,
  },
  {
    img: "/icons/bic.svg",
    company: "BIC",
    amount: "US$ 47,000,000",
    transaction: "Sale of 75% Stake in BIC to First Bank",
    country: "DR Congo",
    year: 2011,
  },
  {
    img: "/icons/fron.svg",
    company: "FEDERAL REPUBLIC OF NIGERIA",
    amount: "US$ 500,000,000",
    transaction: "Debut Eurobond",
    country: "Nigeria",
    year: 2011,
  },
  {
    img: "/icons/ecobank.svg",
    company: "Ecobank (ETI)",
    transaction: "Sale of 19.58% stake in ETI to PIC",
    country: "Togo",
    year: 2012,
  },
  {
    img: "/icons/chivita.svg",
    company: "Chivita PLC",
    amount: "US$ 40,000,000",
    transaction: "OPIC Financing",
    country: "Nigeria",
    year: 2012,
  },
  {
    img: "/icons/amcon.svg",
    company: "AMCON (Asset Management Corporation of Nigeria)",
    transaction: "Advisory on exit options for the nationalized banks",
    country: "Nigeria",
    year: 2013,
  },
  {
    img: "/icons/uba.svg",
    company: "United Bank for Africa (UBA)",
    amount: "US$ 300,000,000",
    transaction: "7.75% Due 2024 Reg S/144A Eurobond Issue",
    country: "Nigeria",
    year: 2013,
  },
  {
    img: "/icons/seplat.svg",
    company: "Seplat",
    amount: "US$ 500,000,000",
    transaction: "IPO and Dual-Listing",
    country: "Nigeria",
    year: 2014,
  },
  {
    img: "/icons/helios.svg",
    company: "Helios",
    transaction: "Sell Down of Helios' 12.5% Stake in Equity Bank",
    country: "Kenya",
    year: 2015,
  },
  {
    img: "/icons/avenue_group.svg",
    company: "Avenue Healthcare Group",
    transaction: "Sale of 100% of Avenue Healthcare Group",
    country: "Kenya",
    year: 2017,
  },
  {
    img: "/icons/bank_kigali.svg",
    company: "Bank of Kigali",
    amount: "US$ 70,000,000",
    transaction: "Rights Issue & Cross-Listing of Bank of Kigali",
    country: "Rwanda",
    year: 2018,
  },
  {
    img: "/icons/accelerex.svg",
    company: "Accelerex Holdings",
    amount: "US$ 20,000,000",
    transaction: "Equity Placement in Accelerex Holdings",
    country: "Nigeria",
    year: 2020,
  },
  {
    img: "/icons/etisalat.svg",
    company: "Etisalat",
    amount: "US$ 650,000,000",
    transaction: "Etisalat Project Financing",
    country: "Nigeria",
    year: 2021,
  },
  {
    img: "/icons/glng.svg",
    company: "GLNG",
    amount: "NGN 5,500,000,000",
    transaction: "Series 1 Guaranteed Fixed Rate Bond",
    country: "Nigeria",
    year: 2021,
  },
  {
    img: "/icons/lsg.svg",
    company: "Lagos State Government",
    amount: "NGN 130,000,000,000",
    transaction: "Bond Issuance by the Lagos State Government",
    country: "Nigeria",
    year: 2021,
  },
  {
    img: "/icons/northsouth.svg",
    company: "North South Power Limited",
    amount: "NGN 6,300,000,000",
    transaction: "Green Bond Issuance",
    country: "Nigeria",
    year: 2021,
  },
  {
    img: "/icons/gerugu.svg",
    company: "Geregu Power PLC",
    amount: "NGN 40,000,000,000",
    transaction: "Bond Issuance for Geregu Power PLC",
    country: "Nigeria",
    year: 2021,
  },
  {
    img: "/icons/mtn.svg",
    company: "MTN",
    amount: "NGN 115,000,000,000",
    transaction: "Local Currency Bond Issuance for MTN",
    country: "Nigeria",
    year: 2022,
  },
  {
    img: "/icons/ecobank.svg",
    company: "Ecobank (ETI)",
    transaction:
      "Strategic Advisory to ETI on recapitalization of East African Subsidiary",
    country: "East Africa",
    year: 2023,
  },
  {
    img: "/icons/radix.png",
    company: "Radix Pension Managers",
    transaction: "Sale of 80% stake in Radix Pension Managers",
    country: "Nigeria",
    year: 2023,
  },
];

// ==============================
// Investment Management Section
// ==============================

export const investmentServices = [
  {
    title: "Portfolio Management",
    description:
      "We design and manage bespoke investment portfolios tailored to meet the unique goals and risk profiles of our clients. Leveraging data-driven insights and disciplined processes, we aim to optimize returns while safeguarding investments against market volatility.",
    img: "/investment-management/portfolio.svg",
  },
  {
    title: "Wealth Advisory",
    description:
      "Our wealth advisory services go beyond traditional investment solutions, offering personalized financial planning and asset allocation strategies to help individuals and institutions build long-term wealth.",
    img: "/investment-management/advisory.svg",
  },
  {
    title: "Alternative Investments",
    description:
      "We explore innovative investment opportunities in alternative asset classes, providing access to high-growth sectors like private equity, venture capital, and real estate for clients seeking portfolio diversification.",
    img: "/homepage/investment-banking.svg",
  },
  {
    title: "Institutional Solutions",
    description:
      "With a deep understanding of institutional requirements, we offer tailored solutions for pension funds, endowments, and corporate treasuries, helping them achieve their financial objectives efficiently.",
    img: "/homepage/investment-management.png",
  },
];

// ==============================
// Research trading Section
// ==============================

export const researchTradingTwoCol = [
  {
    title: "Actionable Research",
    description:
      "Our team delivers insightful and actionable research on local equities and fixed income markets, tailored to support informed decision-making. We combine top-down economic analysis with bottom-up fundamental equities research, covering key sectors across the African and Emerging Markets (EM) landscape.",
    img: "/research-trading/auction.svg",
  },
  {
    title: "Comprehensive Market Intelligence",
    description:
      "With a focus on economic trends, market dynamics, and sector-specific opportunities, our research provides a strategic edge to investors navigating complex African and EM markets.",
    img: "/research-trading/market.svg",
  },
];

export const researchTradingThreeCol = [
  {
    title: "Efficient Trade Execution",
    description:
      "Leveraging advanced technology, our trading services ensure best-in-class execution, speed, and confidentiality for equities, fixed income, derivatives, and commodities trades.",
    img: "/research-trading/trade.svg",
  },
  {
    title: "Diverse Client Solutions",
    description:
      "We cater to international investors, institutional clients, local pension funds, high-net-worth individuals (HNIs), and retail investors, tailoring our services to meet diverse investment needs and objectives.",
    img: "/research-trading/solution.svg",
  },
  {
    title: "Technology-Driven Excellence",
    description:
      "Our state-of-the-art trading infrastructure delivers seamless access to both local and global markets, ensuring precision, reliability, and optimal outcomes for every transaction.",
    img: "/research-trading/technology.svg",
  },
];

// ==============================
// Business commitment Section
// ==============================

export const africaPromise = [
  {
    title: "Drive Inclusion",
    description:
      "We champion inclusive growth by supporting women-led enterprises, youth innovation, and underserved communities.",
    img: "/business-commitment/drive-inclusion.svg",
  },
  {
    title: "Support Communities",
    description:
      "We believe that true progress is achieved when communities thrive. We measure our success not just in terms of monies donated towards education and advancing healthcare, but in hours volunteered, communities supported and lives changed.",
    img: "/business-commitment/support-communities.svg",
  },
  {
    title: "Empower Businesses",
    description:
      "We will provide tailored financial and investment solutions to help African businesses scale, compete globally, and create jobs.",
    img: "/business-commitment/empower-businesses.svg",
  },
  {
    title: "Foster Development",
    description:
      "By investing in critical sectors such as infrastructure, energy, and technology, we enable the continent's progress toward a brighter future.",
    img: "/business-commitment/foster-development.svg",
  },
];

type TJob = {
  id: number;
  category: string;
  title: string;
  description: string;
  location: string;
  type: string;
};

export const jobs: TJob[] = [
  {
    id: 1,
    category: "Students & Graduate Internship",
    title: "Internship 2024",
    description: "We're looking for student and graduate interns to join our team",
    location: "Lagos, Nigeria",
    type: "Full-time",
  },
  {
    id: 2,
    category: "Experienced Professionals",
    title: "Job Title",
    description: "We're looking for VPs, Associates and Analysts to join our team.",
    location: "Lagos, Nigeria",
    type: "Full-time",
  },
];

// ==============================
// Contact Section
// ==============================
export const contactDetails = [
  {
    icon: ChatBubbleLeftRightIcon,
    title: "Chat to support",
    description: "We're here to help.",
    contact: "info@acqmanagers.com",
  },
  {
    icon: MapPinIcon,
    title: "Visit our office HQ",
    description:
      "Plot 1062 B Abagbon Close, Off Ologun Agbaje Street, Victoria Island, Lagos, Nigeria",
    contact: null,
  },
  {
    icon: PhoneIcon,
    title: "Call us",
    description: "Mon–Fri from 8am to 5pm.",
    contact: "+1 (555) 000-0000",
  },
];
